// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  text-align: center;
  padding: 2rem;
}

.app h1 {
  color: #282c34;
  font-size: 2rem;
  margin-bottom: 1rem;
}

.app p {
  color: #555;
  font-size: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/app.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB","sourcesContent":[".app {\n  text-align: center;\n  padding: 2rem;\n}\n\n.app h1 {\n  color: #282c34;\n  font-size: 2rem;\n  margin-bottom: 1rem;\n}\n\n.app p {\n  color: #555;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
